/* AlmiDecor: snapshot komunikatu o terminie przy dodaniu do koszyka.
   Tylko prywatna property; niczego nie zmienia w koszyku ani checkout. */
(() => {
  'use strict';

  if (window.__almiShippingSnapshotLoaded) return;
  window.__almiShippingSnapshotLoaded = true;

  const inputSelector = 'input[data-almi-shipping-snapshot]';
  const noteSelectors = [
    '.product-info__block-item[data-block-type="free-shipping-badge"] .product-delivery-note__text',
    '.product-delivery-note__text',
    '.rug-purchase-notes .rug-delivery',
    '.rug-buybox .rug-delivery',
    '.product-info__block-item[data-block-type="delivery-time"] p'
  ];
  const observedNotes = new WeakSet();

  function getDeliveryText(form) {
    const closestProduct = form.closest('product-rerender');
    const section = form.closest('.shopify-section');
    const scopes = [closestProduct, section].filter(Boolean);
    if (!scopes.length) scopes.push(document);

    for (const scope of scopes) {
      for (const selector of noteSelectors) {
        const element = scope.querySelector(selector);
        if (!element || element.closest('[hidden]')) continue;

        const text = (element.textContent || '').replace(/\s+/g, ' ').trim();
        if (text && !/^darmowa wysyłka$/i.test(text)) return text;
      }
    }
    return '';
  }

  function updateForm(form) {
    if (!form || typeof form.querySelector !== 'function') return;
    const input = form.querySelector(inputSelector);
    if (!input) return;

    const displayedTerm = getDeliveryText(form);
    if (displayedTerm) input.value = displayedTerm;
  }

  function updateForms(scope = document) {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('form').forEach(updateForm);
  }

  function observeDeliveryNotes() {
    document.querySelectorAll(noteSelectors.join(',')).forEach(note => {
      if (observedNotes.has(note)) return;
      observedNotes.add(note);

      const observer = new MutationObserver(() => {
        updateForms(note.closest('.shopify-section') || document);
      });
      observer.observe(note, { childList: true, characterData: true, subtree: true });
    });
  }

  function syncAfterVariantChange() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        updateForms();
        observeDeliveryNotes();
      });
    });
  }

  // Capture phase: Shopify Prestige serializes the product form after this.
  document.addEventListener('submit', event => updateForm(event.target), true);

  // Accelerated purchase buttons can bypass the usual product form submit event.
  document.addEventListener('click', event => {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    const paymentButton = target.closest('.shopify-payment-button');
    if (paymentButton) updateForm(paymentButton.closest('form'));
  }, true);

  document.addEventListener('variant:change', syncAfterVariantChange, true);
  document.addEventListener('change', event => {
    const target = event.target;
    const form = target && typeof target.closest === 'function' ? target.closest('form') : null;
    if (form && form.querySelector(inputSelector)) syncAfterVariantChange();
  }, true);

  function initialize() {
    updateForms();
    observeDeliveryNotes();
    syncAfterVariantChange();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
